import { MenuOrientation } from '../../constants';
import type {
  MenuOrientationType,
  IMenuOrientationCssVars,
  IMenuStretchedCssVars,
} from '../../Menu.types';

export const orientationToCssVarsMap: Record<
  MenuOrientationType,
  IMenuOrientationCssVars
> = {
  [MenuOrientation.Horizontal]: {
    '--flex-direction': 'row',
  },
  [MenuOrientation.Vertical]: {
    '--flex-direction': 'column',
  },
};

export const stretchedCssVars: IMenuStretchedCssVars = {
  '--position-box-not-stretched-left': 'unset',
  '--position-box-width': '100vw',
  '--mega-menu-min-width': '100%',
};

export const notStretchedCssVars: IMenuStretchedCssVars = {
  '--position-box-not-stretched-left': 'auto',
  '--position-box-width': '100%',
  '--mega-menu-min-width': 'unset',
};
